import React from "react";
import "./AboutPage.css";

export default function AboutPage() {
  return (
    <div className="about-page">
      <h1 className="about-title">About Chefs2Table</h1>
      
      <div className="about-hero">
        <h2 className="about-subtitle">Connecting Culinary Excellence with Home Dining</h2>
        <p className="about-hero-text">
          Chefs2Table is revolutionizing the way people experience gourmet dining at home. 
          We're building a marketplace that connects talented local chefs with food enthusiasts 
          who crave restaurant-quality meals in the comfort of their own homes.
        </p>
      </div>

      <div className="about-section">
        <h3 className="section-title">🚀 Launching in Toronto</h3>
        <p className="section-text">
          We're excited to announce that Chefs2Table is launching in Toronto as our flagship test market. 
          Toronto's vibrant culinary scene and diverse food culture make it the perfect city to showcase 
          our innovative platform. This strategic launch allows us to refine our operations, build 
          relationships with exceptional local chefs, and create an unparalleled dining experience 
          for our customers.
        </p>
      </div>

      <div className="about-section">
        <h3 className="section-title">👨‍🍳 Why Chefs Choose Chefs2Table</h3>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h4>💰 Competitive Revenue Share</h4>
            <p>Keep 75% of every order with transparent, fair pricing that rewards your culinary expertise.</p>
          </div>
          <div className="benefit-card">
            <h4>📱 Streamlined Operations</h4>
            <p>Our intuitive platform handles orders, payments, and logistics so you can focus on what you do best—cooking.</p>
          </div>
          <div className="benefit-card">
            <h4>🎯 Targeted Marketing</h4>
            <p>We promote your specialties to food enthusiasts who appreciate authentic, chef-crafted meals.</p>
          </div>
          <div className="benefit-card">
            <h4>🏠 Flexible Schedule</h4>
            <p>Cook on your own terms—whether it's evenings, weekends, or special occasions that fit your lifestyle.</p>
          </div>
          <div className="benefit-card">
            <h4>🌟 Build Your Brand</h4>
            <p>Showcase your unique culinary style and build a loyal customer base in your local community.</p>
          </div>
          <div className="benefit-card">
            <h4>📈 Growth Opportunities</h4>
            <p>As we expand to new cities, established chefs get priority access to new markets and opportunities.</p>
          </div>
        </div>
      </div>

      <div className="about-section">
        <h3 className="section-title">🎯 Our Mission</h3>
        <p className="section-text">
          We believe that exceptional food should be accessible to everyone, not just those who can afford 
          fine dining restaurants. By connecting talented chefs directly with customers, we're creating 
          a sustainable ecosystem that benefits everyone—chefs earn fair compensation, customers enjoy 
          restaurant-quality meals at home, and local food culture thrives.
        </p>
      </div>

      <div className="about-section">
        <h3 className="section-title">🌟 What Makes Us Different</h3>
        <ul className="features-list">
          <li><strong>Chef-Centric Approach:</strong> We're built by chefs, for chefs, with deep understanding of culinary operations</li>
          <li><strong>Quality Focus:</strong> Every chef undergoes a rigorous vetting process to ensure exceptional culinary standards</li>
          <li><strong>Local Community:</strong> We celebrate Toronto's diverse culinary heritage and support local food traditions</li>
          <li><strong>Technology Innovation:</strong> Our platform uses cutting-edge technology to streamline operations and enhance customer experience</li>
          <li><strong>Sustainable Model:</strong> Fair compensation for chefs, reasonable prices for customers, and support for local food systems</li>
        </ul>
      </div>

      <div className="about-section">
        <h3 className="section-title">🚀 Join the Culinary Revolution</h3>
        <p className="section-text">
          Whether you're a seasoned professional chef looking to expand your reach, a culinary school graduate 
          ready to launch your career, or a passionate home cook with professional aspirations, Chefs2Table 
          offers the perfect platform to showcase your talents and build your culinary business.
        </p>
        <div className="cta-section">
          <p className="cta-text">
            Ready to be part of Toronto's culinary future? Join our exclusive chef community and start 
            turning your passion into profit.
          </p>
          <a href="/join-team" className="cta-button">Apply to Become a Chef</a>
        </div>
      </div>

      <div className="about-section">
        <h3 className="section-title">📞 Get in Touch</h3>
        <p className="section-text">
          Have questions about joining our chef community? Want to learn more about our Toronto launch? 
          We'd love to hear from you. Contact us to discuss how Chefs2Table can help you achieve your 
          culinary goals.
        </p>
        <a href="/contact" className="contact-link">Contact Our Team</a>
      </div>
    </div>
  );
}



